module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-booking-f50d7da0cdd2bd78eec75491f767f6fa.svg";